var addToCartBtn=document.querySelector('.cart__checkout');
var productBtn=document.querySelector('.add-to-cart');

var gwpExcludeTag= document.querySelector('body').dataset.excludeGwpOffer;
gwpExcludeTag ="_"+gwpExcludeTag;
// Repaint the offer progress bar and the offer blocks below the cart total.
// The previous theme only refreshed these on a cart change, so both sat blank
// until the shopper edited something. gwpOffers is passed openCart=false so it
// never pops the drawer open by itself.
async function refreshOfferBar() {
  if (!document.getElementById('shipping-bar-progress')) return;
  try {
    var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
    var cart = await fetch(url, { credentials: 'same-origin', method: 'GET' })
      .then(function (response) { return response.json(); });
    await gwpOffers(cart, false);
    freeShippingBar(cart, false);
  } catch (error) {
    console.error('Could not refresh the cart offers:', error);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', refreshOfferBar);
} else {
  refreshOfferBar();
}

document.addEventListener('drawerOpen', async function(evt) {
  if (document.querySelector('.card-load')) document.querySelector('.card-load').classList.add('is-loading');
  await refreshOfferBar();
  await upsellSection();
  if (document.querySelector('.card-load')) document.querySelector('.card-load').classList.remove('is-loading');
});

document.addEventListener('cart:updated', async function(evt) {
  if (document.querySelector('.card-load')) document.querySelector('.card-load').classList.add('is-loading');
  console.log("cart:updated",evt.detail.cart);
  if(evt.detail.property=="_offerXProduct")
  {
     await processbuyXgetYOffers(evt.detail.cart)  
  }
  else { //alert("cart:updated");
    await gwpOffers(evt.detail.cart,false); 
     freeShippingBar(evt.detail.cart,false);
  }
 await upsellSection();
});


document.addEventListener('ajaxProduct:added', async function(evt) {
if (document.querySelector('.card-load')) document.querySelector('.card-load').classList.add('is-loading');
  //console.log("ajaxProduct",evt.detail.product);
   var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
    var response = await fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then( response => {
    return  response.json();
})
  if(evt.detail.product.properties && evt.detail.product.properties._offerXProduct ){ 
  processbuyXgetYOffers(response,false)  
  }
  else { 
    gwpOffers(response,false);
    freeShippingBar(response,false);
  }
//if (document.querySelector('.card-load')) document.querySelector('.card-load').classList.remove('is-loading');
});


function freeShippingBar(cart, openCart) {
    // Bail out if the progress-bar markup is absent (e.g. cart page, or the
    // drawer disabled) instead of throwing and breaking every add-to-cart.
    var gwpOfferData = document.getElementById("CartGwpOffer");
    var progressBarEl = document.getElementById("shipping-bar-progress");
    var milestonesEl = document.getElementById("shipping-bar-milestones");
    var messageEl = document.getElementById("shipping-bar-message");
    if (!gwpOfferData || !progressBarEl || !milestonesEl || !messageEl) return;
    const offers = JSON.parse(gwpOfferData.textContent).offers;
    var cartData = cart;
    var cartTotal = cartData.total_price / 100; // Divide by 100 to convert cents to rupees
    var subtractSubstrings = ['_Offer', '_offerXProduct'];

    // Loop through cartData.items and subtract prices of items with specific properties
    cartData.items.forEach(item => {
        if (item.product_type == 'Combos' || item.product_type == 'Kit') {
            cartTotal -= item.line_price / 100; // Divide by 100 to convert cents to rupees
        }
        if (item.properties) {
            for (var prop in item.properties) {
                if (subtractSubstrings.some(substring => prop.includes(substring))) {
                    cartTotal -= item.line_price / 100; // Divide by 100 to convert cents to rupees
                    break;
                }
            }
        }
    });

    //console.log(cartData, "ProgressUpdated cartTotal:", cartTotal);

    const progressBar = document.getElementById('shipping-bar-progress');
    const milestonesContainer = document.getElementById('shipping-bar-milestones');
    const messageContainer = document.getElementById('shipping-bar-message');

    // Clear previous content
    milestonesContainer.innerHTML = '';

    let message = '';
    let progressPercentage = 0;
    let messageSet = false; // Flag to track if the message has been set

    offers.forEach((offer, index) => {
        const milestone = document.createElement('div');
      if(offers.length - 1 > index) {
        var incrementIndex= parseInt(index + 1);
      }
      else { var incrementIndex= index; }
        milestone.className = `shipping-bar__milestone${cartTotal > offer.cart_total_above ? ' active' : ''}`;

        const milestoneIndicator = document.createElement('div');
        milestoneIndicator.className = 'shipping-bar__milestone-indicator';
        milestoneIndicator.style.left = `${(offer.cart_total_above / offers[incrementIndex].cart_total_above) * 100}%`;
        milestone.appendChild(milestoneIndicator);

        const milestoneText = document.createElement('div');
        milestoneText.className = 'shipping-bar__milestone-text';
        milestoneText.textContent = `₹${offer.cart_total_above}`;
      //console.log(incrementIndex,offer.cart_total_above,"offers[offers.length - 1].cart_total_above:",offers[offers.length - 1].cart_total_above)
       // milestoneText.style.left = `${(offer.cart_total_above / offers[offers.length - 1].cart_total_above) * 100}%`;
      milestoneText.style.left = `${(offer.cart_total_above / offers[incrementIndex].cart_total_above) * 100}%`;
        milestone.appendChild(milestoneText);

        milestonesContainer.appendChild(milestone);

        if (cartTotal > offer.cart_total_above) {
            if (index === offers.length - 1) {
                // If this is the last offer, show the post message
                message = offer.message_if_cart_value_is_greater_than_offer_value;
            } else {
                // Otherwise, continue to the next offer
                messageSet = false;
            }
        } else if (!messageSet) {
            // If the cart total is less than the current offer and message is not yet set
            var remainingAmount = Math.round(offer.cart_total_above - cartTotal);
          if(remainingAmount == 0) {remainingAmount = 1 }
            var titleEl = document.querySelector('#offerPriceContent_' + offer.offerProperty);
            message = offer.message_if_cart_value_is_less_than_offer_value.replace("[value]", remainingAmount).replace('[title]', titleEl ? titleEl.dataset.productTitle : '');
            messageSet = true;
        }

        if (cartTotal > offer.cart_total_above) {
            progressPercentage = ((index + 1) / offers.length) * 100;
        } else if (!progressPercentage) {
          //console.log("cartTotal:",cartTotal,"offer.cart_total_above:",offer.cart_total_above,"((index + 1) / offers.length):",((index + 1) / offers.length))
            progressPercentage = (cartTotal / offers[offers.length - 1].cart_total_above) * ((index + 1) / offers.length) * 100;
           //console.log("progressPercentage:",progressPercentage);
        }
    });

    // Ensure progressPercentage does not exceed 100%
    progressPercentage = Math.min(progressPercentage, 100);

    progressBar.style.width = `${progressPercentage}%`;
    messageContainer.textContent = message;
}

// Fetch the section using the Shopify Section Rendering API
  async function upsellSection() {
  const sectionUrl = window.Shopify.routes.root + 'cart?view=upsell-items';
  const response = await fetch(sectionUrl);
  const sectionData = await response.text();
  const html = document.createElement('div');
   html.innerHTML = sectionData;
   var upsellContainer = document.querySelector(".upsell__products_container");
   if (!upsellContainer) return;
   upsellContainer.innerHTML = html.innerHTML;
   var CartDrawer = document.querySelector('#CartDrawer');
   if (!CartDrawer) return;
  if(document.querySelector("#upsellFlickity")){eval(document.querySelector("#upsellFlickity").innerHTML)}
   CartDrawer.querySelectorAll('.upsell-button').forEach(function(upsell){
   upsell.addEventListener('click', async function(evt) {
    if (addToCartBtn) addToCartBtn.classList.add('btn--loading');

      // currentTarget, not target: the button wraps a <span>, so a click on the
      // label would otherwise read data-id off the span.
      var button = evt.currentTarget;
      var variants = button.closest('.cart__item--variants');
      var variantInput = variants && variants.querySelector('[name="variant"]');
      var variantId = (variantInput && variantInput.value) || button.dataset.id;

      var item = {
        'id': variantId,
        'quantity': 1
      };

      // Carry the GWP exclude property so upsell items do not count toward the
      // free-gift threshold. Merged in from the old theme's jQuery handler,
      // which was the only path that set this.
      var excludeInput = variants && variants.querySelector('#upsellProperties');
      if (excludeInput && excludeInput.value) {
        item.properties = {};
        item.properties['_' + excludeInput.value] = 'true';
      }

      let formData = { 'items': [item] };
      var result = await addProducts(formData);
      var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
      var response = await fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then( response => {
    return  response.json();
    })
     await gwpOffers(response);
     await upsellSection();
     if (addToCartBtn) addToCartBtn.classList.remove('btn--loading');
})
})
}



async function gwpOffers(cart,openCart){ 
  var scriptElement=document.querySelector("#CartGwpOffer");
  if (!scriptElement) return;
  if (addToCartBtn) addToCartBtn.classList.add('btn--loading');
  var cartData= cart;
  var cartTotal = cartData.total_price;
  var gwpOffers = scriptElement.textContent;
  gwpOffers = JSON.parse(gwpOffers);
// Define the substrings and properties to consider for subtracting from cartTotal
//var subtractSubstrings = ['buyX', '_offerXProduct'];
var subtractSubstrings = ['_Offer', '_offerXProduct'];
// Loop through cartData.items and subtract prices of items with specific properties
cartData.items.forEach(item => {
  if(item.product_type == 'Combos' || item.product_type == 'Kit'){
  cartTotal -= item.line_price;  
  }
  if (item.properties) {
    for (var prop in item.properties) {
      if (subtractSubstrings.some(substring => prop.includes(substring))) {
        cartTotal -= item.line_price;
        break;
      }
    }
  }
});
console.log(cartData,"Updated cartTotal:", cartTotal);
//In this code, we use the subtractSubstrings array to define the substrings and properties to consider for subtracting from cartTotal. The code then iterates through each item in cartData.items, and for each property in item.properties, it checks if the property key contains any of the specified substrings using the some method. If a match is found, it subtracts the item's price from cartTotal.

  cartTotal = cartTotal/100;
// Iterate through each offer in gwpOffers.offers
  document.querySelectorAll('.offerPriceContentSection').forEach(div => div.style.display = 'none');
  var gwpMessageDisplayPre=false
  var gwpMessageDisplayPost=false
   // Arrays to store formData objects for add and remove operations

  const addFormDataArray=[];
  let finalFormData = {};
  const keyIds = [];
  const promises = gwpOffers.offers.map(async offer => {
  // Check if cartTotal is less than cart_total_above
  //console.log(cartTotal, "<", offer.cart_total_above)
  if (cartTotal <= offer.cart_total_above) {
    // offer message display on the bottom
    var offerEl = document.querySelector('#offerPriceContent_'+offer.offerProperty);
    if(!gwpMessageDisplayPre && offerEl){
    var diff= Math.round(offer.cart_total_above-cartTotal);
  if(diff ==0) { diff = 1;}
    var offerMessage= (offer.message_if_cart_value_is_less_than_offer_value).replace('[value]',diff);
      offerMessage= `<div class="offer-content"><span>`+(offerMessage).replace('[title]',offerEl.dataset.productTitle)+`</span>`;
    var image=  `<div class="offer-img"><img src="${offerEl.dataset.productImg}" /></div>`;
    var bottom_message=`<div><span>${offerEl.dataset.productTitle}</span></div><div><span class="cart__price cart__price--strikethrough">${offerEl.dataset.productPrice}</span><span class="ajaxcart__price">FREE</span></div></div>`;
    offerEl.innerHTML=image+offerMessage+bottom_message;
    offerEl.style.display="";
    gwpMessageDisplayPre=true;
    }
    // Check if the offerProperty value is found in CartData.items
    let offerPropertyFound = cartData.items.find(item => item.properties && item.properties._Offer==offer.offerProperty);
    //console.log("offerPropertyFound",offerPropertyFound)
    if (offerPropertyFound) {
      var keyId=  offerPropertyFound.key;
      keyIds.push(keyId);
      
       //var result= await removeProducts(formData); 
      //console.log(`Product '${offer.offerProperty}' removed from the cart.`);
    }
  }
  else {
  
    // Check if the offerProperty value is found in CartData.items
    let offerPropertyFound = cartData.items.some(item => item.properties && item.properties._Offer==offer.offerProperty);
    if (!offerPropertyFound) {
      //   let formData = {
      //   'id': offer.free_product_main,
      //   'quantity': 1,
      //   "properties" : {
      //   "_Offer": `${offer.offerProperty}`,
      //   "_Offer-limit":`${offer.cart_total_above}`
      // }
      //   };
        
    
   // addFormDataArray.push(formData);
    //console.log(`Product '${offer.offerProperty}' added to the cart.`);
    //console.log("offerPropertyFound",offerPropertyFound)
     var offerElPost = document.querySelector('#offerPriceContent_'+offer.offerProperty);
     if(!gwpMessageDisplayPost && offerElPost){
    offerElPost.innerHTML=offer.message_if_cart_value_is_greater_than_offer_value;
    offerElPost.style.display="";
    gwpMessageDisplayPost=true
     }
    }
    else{
    var offerElHave = document.querySelector('#offerPriceContent_'+offer.offerProperty);
    if(!gwpMessageDisplayPost && offerElHave){
    offerElHave.innerHTML=offer.message_if_cart_value_is_greater_than_offer_value;
    offerElHave.style.display="";
    gwpMessageDisplayPost=true
    }
    }
    
  }
   
});

await Promise.all(promises);
if(addFormDataArray.length >0){
  /*  const formDataAdd = {
    'items': addFormDataArray
  };
   await addProducts(formDataAdd);  
  document.dispatchEvent(new CustomEvent('cart:build'));
 */
  if(openCart) { document.querySelector(".js-drawer-open-cart").click();}
}  
else if(keyIds.length >0){
 /*   const commonValue = 0;
// Use reduce to create the object
   const formDataObject = keyIds.reduce((obj, keyId) => {
  obj[keyId] = commonValue;
  return obj;
   }, {});
  await updateProducts(formDataObject); 
  document.dispatchEvent(new CustomEvent('cart:build'));
  */
  if(openCart) { document.querySelector(".js-drawer-open-cart").click();}
}
else {
  if (addToCartBtn) addToCartBtn.classList.remove('btn--loading')
  if (document.querySelector('.card-load')) document.querySelector('.card-load').classList.remove('is-loading');
  }  
  
} 



async function processbuyXgetYOffers(cart, openCart) {
  var scriptElement = document.querySelector("#CartBuyXAndGetYOffer");
  if (!scriptElement) return;
  if (addToCartBtn) addToCartBtn.classList.add('btn--loading');
  var cartData = cart;
  var gwpOffers = JSON.parse(scriptElement.textContent);

  const promises = gwpOffers.offers.map(async offer => {
    if (offer.enable_offers) {
      const productXQuantities = {};
      let productYInCart = cartData.items.find(item => item.id === offer.product_y);

      for (let j = 1; j <= 25; j++) {
        const productXId = offer[`choose_product_x_${j}`];
        const productXInCart = cartData.items.find(item => item.id === productXId);
        if (productXInCart) {
          productXQuantities[productXId] = productXInCart.quantity;
        }
      }

      const newXIds = Object.keys(productXQuantities);
      const existingYQuantity = productYInCart ? productYInCart.quantity : 0;

      if (existingYQuantity < newXIds.length) {
        // Add new Y products if necessary
        const formData = {
          'items': Array.from({ length: newXIds.length - existingYQuantity }, () => ({
            'id': offer.product_y,
            'quantity': 1,
            'properties': {
              '_Offer': offer.offerProperty
            }
          }))
        };
        //await addProducts(formData);
      } else if (existingYQuantity > newXIds.length) {
        // Remove excess Y products if necessary
        const formData = {
          'id': productYInCart.key,
          'quantity': newXIds.length
        };
        //await removeProducts(formData);
      }

      if (productYInCart && productYInCart.line_price > 0) {
        // Remove Y product if it's not part of the offer anymore
        const formData = {
          'id': productYInCart.key,
          'quantity': 0
        };
        //await removeProducts(formData);
      }
    }
  });

  await Promise.all(promises);

  document.dispatchEvent(new CustomEvent('cart:build'));
  if (addToCartBtn) addToCartBtn.classList.remove('btn--loading');
  if (productBtn) productBtn.classList.remove('btn--loading');
  if (document.querySelector('.card-load')) document.querySelector('.card-load').classList.remove('is-loading');
  if (openCart) {
    document.querySelector(".js-drawer-open-cart").click();
  }
}



async function addProducts(formData){
return await fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
.then(async response => {
  return await response.json();
})
.catch((error) => {
  console.error('Error:', error);
});
}
async function removeProducts(formData){
await fetch(window.Shopify.routes.root + 'cart/change.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
.then( async response => {
  return await response.json();
})
.catch((error) => {
  console.error('Error:', error);
});
}

async function updateProducts(updates){
  await fetch(window.Shopify.routes.root + 'cart/update.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({ updates })
})
.then(response => {
  return response.json();
})
.catch((error) => {
  console.error('Error:', error);
});
}
    // The old theme had a second, jQuery-based .upsell-button click handler here.
    // It has been merged into the vanilla handler in upsellSection() above,
    // which now also sends the GWP exclude property. jQuery is no longer used.

/* ---------------------------------------------------------------------------
   Collection / featured-collection grid add to cart.

   Ported from the previous theme, where it was a jQuery handler in theme.js.
   Rewritten in vanilla JS, and it now actually sends the GWP exclude property
   (the old version built its own payload and silently dropped the hidden input
   the form contained, so excluded products still counted toward the gift
   threshold).
--------------------------------------------------------------------------- */
(function () {
  var MAX_QTY_PER_PRODUCT = 4;

  document.addEventListener('click', async function (evt) {
    var button = evt.target.closest('.collection_a2c');
    if (!button) return;

    evt.preventDefault();

    var variantId = button.dataset.variantId;
    if (!variantId) return;

    button.classList.add('btn--loading');

    try {
      // Enforce the per-product quantity cap against what is already in the cart.
      var cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', {
        credentials: 'same-origin'
      });
      var cart = await cartResponse.json();

      var inCart = 0;
      cart.items.forEach(function (item) {
        if (String(item.variant_id) === String(variantId)) inCart += item.quantity;
      });

      if (inCart + 1 > MAX_QTY_PER_PRODUCT) {
        alert('Quantity Limit is ' + MAX_QTY_PER_PRODUCT + ' for each products.');
        return;
      }

      var item = { id: variantId, quantity: 1 };

      // Keep this line item out of the gift-with-purchase total.
      if (button.dataset.gwpExclude) {
        item.properties = {};
        item.properties['_' + button.dataset.gwpExclude] = 'true';
      }

      var added = await addProducts({ items: [item] });

      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product: added, addToCartBtn: button }
      }));

      if (theme && theme.Drawers) {
        new theme.Drawers('CartDrawer', 'cart').open();
      }
    } catch (error) {
      console.error('Grid add to cart failed:', error);
    } finally {
      button.classList.remove('btn--loading');
    }
  });
})();
/* ---------------------------------------------------------------------------
   Product grid countdown timer.
   Ported from the previous theme, where it was an inline script inside
   featured-collection.liquid.
--------------------------------------------------------------------------- */
    
  function countDownTimerNew(endDate,index,sectionId){
    
  const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;
    let datee = new Date(endDate);
   //datee.setMonth(datee.getMonth() - 1); 
     let countDown = datee.getTime();  
     let x = setInterval(function() {    

        let now = new Date().getTime(),
            distance = countDown - now;
         if(Math.floor(distance / (day)) == 0) { document.querySelector(".daysDiv_"+index+"_"+sectionId).style.display='none';}      
         var daysValue = Math.floor(distance / (day));
         daysValue =daysValue.toString().split('');
         if(daysValue.length == 1) { daysValue.splice(0, 0, "0");}
       
         var hoursValue = Math.floor((distance % (day)) / (hour));
         hoursValue =hoursValue.toString().split('');
         if(hoursValue.length == 1) { hoursValue.splice(0, 0, "0");}
         var minutesValue = Math.floor((distance % (hour)) / (minute));
         minutesValue =minutesValue.toString().split('');
         if(minutesValue.length == 1) { minutesValue.splice(0, 0, "0");}
         var secondsValue = Math.floor((distance % (minute)) / second);
         secondsValue =secondsValue.toString().split('');
         if(secondsValue.length == 1) { secondsValue.splice(0, 0, "0");}
          document.querySelector(".days_1_"+index+"_"+sectionId).innerText = daysValue[0];
          document.querySelector(".days_2_"+index+"_"+sectionId).innerText = daysValue[1];
          document.querySelector(".hours_1_"+index+"_"+sectionId).innerText = hoursValue[0];
          document.querySelector(".hours_2_"+index+"_"+sectionId).innerText = hoursValue[1];
          document.querySelector(".minutes_1_"+index+"_"+sectionId).innerText = minutesValue[0];
          document.querySelector(".minutes_2_"+index+"_"+sectionId).innerText = minutesValue[1];
          document.querySelector(".seconds_1_"+index+"_"+sectionId).innerText = secondsValue[0];
          document.querySelector(".seconds_2_"+index+"_"+sectionId).innerText = secondsValue[1];
       
        //do something later when date is reached
        if (distance < 0) { 
          let headline = document.querySelector("#headline_"+index+"_"+sectionId),
              countdown = document.querySelector("#countdown_"+index+"_"+sectionId);
          if (headline) headline.innerText = "";
          countdown.style.display = "none";  
          clearInterval(x);
        }
        //seconds
      }, 1000)
  }